import React from 'react';
import { coreCatalogItemApi } from '@cp/entities/catalogItem';
import { ApiServerEntityIDType } from '@cp/utils/apiServer/types';
import { useRouter } from '@cp/shared/router';
import { useClientWebResolver } from '@cp/entities/clientWebRoutes';
import { ClientWebPage } from '@common/model/meta/clientWebPage';
// FIXME: wrong entrypoint
import { useErrorHandler } from 'src/features/registration/lib';

export interface ConnectMethod {
  (catalogItemId: ApiServerEntityIDType): Promise<void>;
}

export const useConnect = (): ConnectMethod => {
  const [connectWithAuthor] = coreCatalogItemApi.endpoints.connectWithAuthor.useMutation();
  const router = useRouter();
  const resolver = useClientWebResolver();
  const errorHandler = useErrorHandler();

  return React.useCallback<ConnectMethod>(
    async (catalogItemId) => {
      const response = await connectWithAuthor({ id: catalogItemId });
      if ('error' in response) {
        errorHandler(response.error);
        return;
      }
      await router.navigate(resolver.resolve({ page: ClientWebPage.ProfileMessages, queryParams: { dialogId: response.data.dialogId } }));
    },
    [connectWithAuthor, router, resolver, errorHandler],
  );
};
